export enum TypoVariant {
  HeadingL1 = 'hl-1',
  HeadingL2 = 'hl-2',
  HeadingL3 = 'hl-3',
  Heading1 = 'h-1',
  Heading2 = 'h-2',
  Heading3 = 'h-3',
  Heading4 = 'h-4',
  Heading5 = 'h-5',
  Heading6 = 'h-6',
  BodyXLRegular = 'body-xl-400',
  BodyLRegular = 'body-l-400',
  BodySRegular = 'body-s-400',
  BodyMRegular = 'body-m-400',
  BodyXSRegular = 'body-xs-400',
  BodyXLMedium = 'body-xl-500',
  BodyLMedium = 'body-l-500',
  BodyMMedium = 'body-m-500',
  BodySMedium = 'body-s-500',
  BodyXSMedium = 'body-xs-500',
  BodyXLBold = 'body-xl-700',
  BodyLBold = 'body-l-700',
  BodyMBold = 'body-m-700',
  BodySBold = 'body-s-700',
  BodyXSBold = 'body-xs-700',
  BodyXLRegularShort = 'body-xl-400-short',
  BodyLRegularShort = 'body-l-400-short',
  BodySRegularShort = 'body-s-400-short',
  BodyMRegularShort = 'body-m-400-short',
  BodyXSRegularShort = 'body-xs-400-short',
  BodyXLMediumShort = 'body-xl-500-short',
  BodyLMediumShort = 'body-l-500-short',
  BodyMMediumShort = 'body-m-500-short',
  BodySMediumShort = 'body-s-500-short',
  BodyXSMediumShort = 'body-xs-500-short',
  BodyXLBoldShort = 'body-xl-700-short',
  BodyLBoldShort = 'body-l-700-short',
  BodyMBoldShort = 'body-m-700-short',
  BodySBoldShort = 'body-s-700-short',
  BodyXSBoldShort = 'body-xs-700-short',
  CaptionMRegular = 'caption-m-400',
  CaptionSRegular = 'caption-s-400',
  CaptionMBold = 'caption-m-700',
  CaptionSBold = 'caption-s-700',
  CaptionMRegularShort = 'caption-m-400-short',
  CaptionSRegularShort = 'caption-s-400-short',
  CaptionMBoldShort = 'caption-m-700-short',
  CaptionSBoldShort = 'caption-s-700-short',
}
